import { Link } from 'react-router-dom';
import { MessageCircle, Mail, Facebook } from 'lucide-react';
import { BRAND, whatsappLink } from '@/lib/constants';
import BrandMark from './BrandMark';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-[#07111F] pt-24 pb-10 mt-24">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <BrandMark size="md" />
            <p className="mt-6 max-w-md font-inter text-white/60 text-base leading-relaxed">
              Helping South Africans who believe they were wrongfully arrested or unlawfully detained understand their constitutional rights and pursue a possible civil claim.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/calculator"
                data-testid="footer-calculate-btn"
                className="inline-flex items-center justify-center rounded-full bg-[#FFD400] px-6 py-3.5 text-sm font-poppins font-bold uppercase tracking-wide text-[#07111F]"
              >
                Start Free Assessment
              </Link>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-6 py-3.5 text-sm font-inter font-semibold text-white/90"
              >
                <MessageCircle className="h-4 w-4 text-[#39A8FF]" /> WhatsApp Us
              </a>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white/70 hover:border-[#39A8FF] hover:text-[#39A8FF] transition-colors"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-whatsapp-icon"
                aria-label="WhatsApp"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white/70 hover:border-[#25D366] hover:text-[#25D366] transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
              </a>
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-mail-icon"
                aria-label="Email"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white/70 hover:border-[#FFD400] hover:text-[#FFD400] transition-colors"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#FFD400] font-inter font-bold mb-5">Explore</div>
            <ul className="space-y-3 font-inter text-white/70">
              <li><Link data-testid="footer-link-home" to="/" className="hover:text-white">Home</Link></li>
              <li><Link data-testid="footer-link-calculator" to="/calculator" className="hover:text-white">Free Assessment</Link></li>
              <li><Link data-testid="footer-link-rights" to="/know-your-rights" className="hover:text-white">Know Your Rights</Link></li>
              <li><Link data-testid="footer-link-cases" to="/case-studies" className="hover:text-white">Case Examples</Link></li>
              <li><Link data-testid="footer-link-faq" to="/faq" className="hover:text-white">FAQ</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white">About</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#FFD400] font-inter font-bold mb-5">Contact</div>
            <ul className="mt-6 space-y-3 font-inter text-white/70">
              <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-1 text-[#39A8FF]" /><a href={`mailto:${BRAND.email}`} className="hover:text-white break-all">{BRAND.email}</a></li>
              <li className="flex items-start gap-3"><MessageCircle className="h-4 w-4 mt-1 text-[#39A8FF]" /><a href={whatsappLink()} target="_blank" rel="noreferrer noopener" className="hover:text-white">Chat on WhatsApp</a></li>
            </ul>
            <div className="mt-6 text-[11px] uppercase tracking-[0.24em] text-[#FFD400] font-inter font-bold mb-4">Legal</div>
            <ul className="space-y-3 font-inter text-white/70 text-sm">
              <li><Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-white">Privacy Policy · POPIA</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="hover:text-white">Terms of Use</Link></li>
              <li><Link data-testid="footer-link-disclaimer" to="/disclaimer" className="hover:text-white">Disclaimer</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs font-inter text-white/40">
          <div>© {new Date().getFullYear()} Wrongfully Arrested SA. All rights reserved.</div>
          <div className="max-w-xl md:text-right">
            General legal information only. Not legal advice. Viewing this site does not create an attorney-client relationship.
          </div>
        </div>
      </div>
    </footer>
  );
}
